import { FunctionComponent, useContext } from 'react';
import { ApplicationLayoutFooter } from 'layouts/ApplicationLayout/components';
import { keys } from 'lodash';
import { languages } from 'common/languages/languages';
import { setLang } from '@ds/base';
import VerifyApplicationContext from 'contexts/VerifyApplicationContext';

const VerifyApplicationFooter: FunctionComponent = () => {
    const context = useContext(VerifyApplicationContext);

    const onChangeLocale = (locale: string) => {
        setLang(locale);
        if (context.updateLanguage) {
            context.updateLanguage(locale);
        }
    };

    return (
        <ApplicationLayoutFooter
            dataQa="footer"
            locales={keys(languages)}
            getCurrentLocale={() => context.language}
            changeLocale={onChangeLocale}
        />
    );
};

export default VerifyApplicationFooter;
